import { Alert, TableCell, TableRow, Typography } from '@mui/material'
import React from 'react'

import useT from '@/i18n/useT'

export function DaiAlert({ message }: { message: string }): React.ReactNode {
  return (
    <Alert severity="info" sx={{ display: 'inline-flex' }}>
      {message}
    </Alert>
  )
}

export type NoDataType = 'noData' | 'needToCollectData'
interface EmptyTableProps {
  totalColumns: number
  message?: string
  noDataType?: NoDataType
}

export function FeatureUnavailable({
  totalColumns,
}: EmptyTableProps): React.ReactNode {
  const { t } = useT()
  return (
    <TableRow>
      <TableCell
        colSpan={totalColumns}
        sx={{
          textAlign: 'center',
          padding: 5,
          backgroundColor: 'primary',
          color: 'primary',
        }}
      >
        <Typography variant="h6" color="textSecondary">
          <DaiAlert message={t('deliciousTable.alert.featureUnavailable')} />
        </Typography>
      </TableCell>
    </TableRow>
  )
}

export function TableNoData({
  totalColumns,
  message,
  noDataType = 'needToCollectData',
}: EmptyTableProps): React.ReactNode {
  const { t } = useT()

  return (
    <TableRow>
      <TableCell colSpan={totalColumns} sx={{ textAlign: 'center' }}>
        <DaiAlert
          message={
            message ||
            (noDataType === 'noData'
              ? t('deliciousTable.noData')
              : t('deliciousTable.needToCollectData'))
          }
        />
      </TableCell>
    </TableRow>
  )
}
